<section class="flex items-center justify-between">
  <soft-ds-tabs
    [(value)]="activeTab"
    [tabs]="mainTabs()"
    variant="underline"
    class="mb-2"
  />
  @if (mode()) {
    <soft-ds-badge variant="outline">{{ modeLabel() | translate }}</soft-ds-badge>
  }
</section>

<form
  [formGroup]="form"
  class="flex flex-col gap-4 overflow-y-auto max-h-[calc(80vh-14rem)]"
>
  @if (activeTab() === 'event') {
    <div class="flex flex-col">
      <span class="soft-label top">Datum</span>
      <soft-ds-date-input
        formControlName="datum"
        placeholder="keine Angabe"
        [readonly]="isReadonly()"
      />
    </div>

    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col">
        <span class="soft-label top">Von</span>
        <soft-ds-time-input
          formControlName="beginTime"
          [readonly]="isReadonly()"
          softFieldValidation
        />
      </div>
      <div class="flex flex-col">
        <span class="soft-label top">Bis</span>
        <soft-ds-time-input
          formControlName="endTime"
          [readonly]="isReadonly()"
          softFieldValidation
        />
      </div>
    </div>

    <div class="flex flex-col">
      <span class="soft-label top">Tour-Nummer</span>
      <soft-ds-input
        formControlName="tour"
        [readonly]="isReadonly()"
        placeholder="keine Angabe"
      />
    </div>

    <div class="flex flex-col">
      <span class="soft-label top">Tour-Ziel</span>
      <soft-ds-input
        formControlName="tourDestination"
        [readonly]="true"
        placeholder="keine Angabe"
      />
    </div>

    <div class="flex flex-col">
      <span class="soft-label top">Kommentar</span>
      <soft-ds-multiline-input
        [lines]="3"
        formControlName="comment"
        [readonly]="isReadonly()"
      />
    </div>

    <div class="grid grid-cols-3 gap-4">
      <div class="flex flex-col">
        <span class="soft-label top">Erstellt von</span>
        <soft-ds-input formControlName="creatorUser" [readonly]="true" />
      </div>
      <div class="flex flex-col">
        <span class="soft-label top">Erstellt am</span>
        <soft-ds-input formControlName="createdAt" [readonly]="true" />
      </div>
      <div class="flex flex-col">
        <span class="soft-label top">Zuletzt geändert am</span>
        <soft-ds-input formControlName="changedAt" [readonly]="true" />
      </div>
    </div>
  }

  @if (activeTab() === 'artefakt') {
    <section class="grid grid-cols-1 md:grid-cols-2 gap-3">
      @for (item of artefaktData; track item.label) {
        <div class="flex flex-col">
          <span class="soft-label top">{{ item.label }}</span>
          <soft-ds-input
            [class.betrag-value-input]="item.label === 'Betrag'"
            [value]="item.value || 'keine Angabe'"
            [readonly]="true"
          />
        </div>
      }
    </section>

    @if (itemsResource.isLoading()) {
      <soft-ds-loading-spinner />
    } @else if (items().length || itemsError()) {
      <soft-ds-accordion variant="boxed">
        <soft-ds-accordion-item>
          <soft-ds-accordion-header>
            <soft-ds-accordion-leading variant="tinted">
              <soft-ds-icon name="fa-regular fa-boxes-stacked" color="current" />
            </soft-ds-accordion-leading>
            <soft-ds-accordion-title>Artikelliste</soft-ds-accordion-title>
          </soft-ds-accordion-header>
          <soft-ds-accordion-content>
            @if (itemsError()) {
              <span class="ds-caption text-light">
                Artikel konnten nicht geladen werden.
              </span>
            } @else {
              <div class="flex flex-col">
                <div class="flex items-center justify-between border-b">
                  <span class="font-semibold">Beschreibung</span>
                  <span class="font-semibold">Menge</span>
                </div>
                @for (item of items(); track item.id) {
                  <div
                    class="flex items-center justify-between py-1 border-b border-(--ds-border-default) last:border-b-0"
                  >
                    <span>{{ item.product.description1 }}</span>
                    <span class="whitespace-nowrap">
                      {{ item.salesQuantity | format: 'QUANTITY.DEFAULT' }}
                      {{ $safeNavigationMigration(item.salesUnit?.key) | einheit }}
                    </span>
                  </div>
                }
              </div>
            }
          </soft-ds-accordion-content>
        </soft-ds-accordion-item>
      </soft-ds-accordion>
    }
  }
</form>

<section class="flex justify-between items-center mt-4">
  @if (status(); as status) {
    <soft-ds-badge [variant]="status.color">
      {{ status.label | translate }}
    </soft-ds-badge>
  }
  <div class="flex gap-2 ml-auto">
    <soft-ds-button
      variant="destructive"
      mode="iconOnly"
      (click)="delete()"
      [disabled]="denyDelete()"
    >
      <soft-ds-icon name="fa-regular fa-trash" />
    </soft-ds-button>
    <soft-ds-button variant="outline" (click)="cancel()">Abbrechen</soft-ds-button>
    <soft-ds-button
      variant="primary"
      [disabled]="form.invalid || isReadonly()"
      (click)="save()"
    >
      Speichern
    </soft-ds-button>
  </div>
</section>
